import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './App.css'
import ListState from './context/list/ListState'
import StoreState from './context/store/StoreState'
import PlaceState from './context/place/PlaceState'
import AuthState from './context/auth/AuthState'
import UserState from './context/user/UserState'
import ItemState from './context/item/ItemState'
import HomeState from './context/home/HomeState'
import NewList from './components/newList/NewList'
import Home from './components/Home'
import Landing from './components/ui/Landing'
import ListsPage from './components/shopList/ListsPage'
import Register from './components/auth/Register'
import Login from './components/auth/Login'
import AppNavBar from './components/layout/AppNavBar'
import Footer from './components/layout/Footer'
import { setAuthToken } from './utils/setAuthToken'
import ItemsPage from './components/items/ItemsPage'
import StoresPage from './components/stores/StoresPage'
import HomesPage from './components/homes/HomesPage'
import Authorizer from './components/auth/Authorizer'
import AboutPage from './components/ui/AboutPage'
import { withComponentLabel } from './utils/debug'
// import TestPage from './components/ui/TestPage'
import VerifyPage from './components/mail/VerificationConfirmation'
import VerificationSent from './components/mail/VerificationSent'
import { PrivateRoute } from './components/routing/PrivateRoute'
import { ErrorBoundary } from './components/routing/ErrorBoundary'
import { ToastContainer } from './components/ui/Toast'
import Unsubscribe from './components/mail/Unsubscribe'
import StoreDetailPage from './components/stores/StoreDetailPage'
import ItemDetailPage from './components/items/ItemDetailPage'

if (localStorage.token) {
  console.log('App.js: localStorage.token exists')
  setAuthToken(localStorage.token)
}

const App = () => {
  return (
    <UserState>
      <PlaceState>
        <AuthState>
          <StoreState>
            <ListState>
              <ItemState>
                <HomeState>
                <Router>
                  <>
                    <Authorizer>
                      <div className="min-h-screen flex flex-col justify-between">
                        <ToastContainer />
                        <AppNavBar />
                        <Routes>
                          <Route
                            exact
                            path="/"
                            element={<Landing />}
                          />
                          <Route
                            exact
                            path="/register"
                            element={
                              <ErrorBoundary>
                                <Register />
                              </ErrorBoundary>
                            }
                          />
                          <Route
                            exact
                            path="/login"
                            element={
                              <ErrorBoundary>
                                <Login />
                              </ErrorBoundary>
                            }
                          />
                          <Route
                            path="/home"
                            element={
                              <PrivateRoute redirectTo="/login">
                                <Home />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/newlist"
                            element={
                              <PrivateRoute redirectTo="/login">
                                <NewList />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/lists"
                            element={
                              <PrivateRoute redirectTo="/login">
                                <ListsPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/items"
                            element={
                              <PrivateRoute redirectTo="/login">
                                <ItemsPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/items/:itemId"
                            element={
                              <PrivateRoute redirectTo="/login">
                                <ItemDetailPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            exact
                            path="/stores"
                            element={
                              <PrivateRoute redirectTo="/login">
                                <StoresPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/stores/:storeId"
                            element={
                              <PrivateRoute redirectTo="/login">
                                <StoreDetailPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            path="/homes"
                            element={
                              <PrivateRoute redirectTo="/login">
                                <HomesPage />
                              </PrivateRoute>
                            }
                          />
                          <Route
                            exact
                            path="/about"
                            element={<AboutPage />}
                          />
                          <Route
                            path="/verification-sent"
                            element={<VerificationSent />}
                          />
                          <Route
                            path="/verify/:token"
                            element={<VerifyPage />}
                          />
                          <Route
                            exact
                            path="/hellothisisatestkthx"
                            element={<StoresPage />}
                          />
                          <Route
                            exact
                            path="/unsubscribe"
                            element={<Unsubscribe />}
                          />
                        </Routes>
                        <Footer />
                      </div>
                    </Authorizer>
                  </>
                </Router>
              </HomeState>
              </ItemState>
            </ListState>
          </StoreState>
        </AuthState>
      </PlaceState>
    </UserState>
  )
}

export default withComponentLabel(App, 'App')
